"use client"

import { Dispatch, SetStateAction, createContext, useContext, useState } from "react"

const ExpandedTagsContext = createContext<
    [string[], Dispatch<SetStateAction<string[]>>] | undefined
>(undefined)

export function ExpandedProvider({ children }: { children: React.ReactNode }) {
    const [expanded, setExpanded] = useState<string[]>(["Thing"])

    return (
        <ExpandedTagsContext.Provider value={[expanded, setExpanded]}>
            {children}
        </ExpandedTagsContext.Provider>
    )
}

export function useExpanded() {
    const context = useContext(ExpandedTagsContext)
    if (context === undefined) {
        throw new Error()
    }

    return context
}
